
const digest = '8aa7261d80452434acb854a76753208f1c5342a80c62bbb7f6190805c0963135';
const classes = {"wrapper":"_wrapper_1a9uq_1"};
const css = `._wrapper_1a9uq_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  